import { withDataRequestActionType } from './actionTypeFormatters';

/**
 * @typedef WithDataRequestInitialState
 * @property {boolean} firstDataRequestCompleted
 * @property {boolean} dataRequestLoading
 * @property {boolean} dataRequestCancelled
 * @property {boolean} dataRequestCompleted
 * @property {boolean} noDataRenderUpdateAllowed
 * @property {boolean} dataRequestError
 * @property {any[]} errors
 */

/**
 * @constant withDataRequestInitialState
 * @type {WithDataRequestInitialState}
 */
export const withDataRequestInitialState = {
  firstDataRequestCompleted: false,
  dataRequestLoading: false,
  dataRequestCancelled: false,
  dataRequestCompleted: false,
  noDataRenderUpdateAllowed: false,
  dataRequestError: false,
  errors: [],
};
/**
 * @param {any} combinedState - redux state
 * @param {object} payload - optional payload (must be an object)
 */
const returnState = (combinedState, payload) => {
  if (payload) {
    return { ...combinedState, ...payload };
  }
  return combinedState;
};

/**
 * @param {import('redux').Reducer} reducer
 * @param {string} reducerName - reducer name as a string for action type namespacing
 */
export function withDataRequest(reducer, reducerName) {
  return (state, action) => {
    const combinedState = {
      ...withDataRequestInitialState,
      ...reducer(state, action),
    };
    const {
      BEGIN,
      LOADING,
      COMPLETED,
      CANCELLED,
      FAILURE,
      RESET,
    } = withDataRequestActionType(reducerName);
    const { type, payload } = action;
    switch (type) {
      case BEGIN:
        return {
          ...returnState(combinedState, payload),
          dataRequestCompleted: false,
          dataRequestCancelled: false,
          dataRequestError: false,
          noDataRenderUpdateAllowed: true,
        };
      case LOADING:
        return {
          ...returnState(combinedState, payload),
          dataRequestLoading: true,
        };
      // catch
      case FAILURE:
        return {
          ...returnState(combinedState, payload),
          dataRequestError: true,
          dataRequestLoading: false,
        };
      // finally
      case COMPLETED:
        return {
          ...returnState(combinedState, payload),
          firstDataRequestCompleted: true,
          dataRequestCompleted: true,
          dataRequestCancelled: false,
          noDataRenderUpdateAllowed: false,
          dataRequestLoading: false,
        };
      case CANCELLED:
        return {
          ...returnState(combinedState, payload),
          dataRequestCancelled: true,
          dataRequestLoading: false,
        };
      case RESET:
        return {
          ...returnState(combinedState, payload),
          firstDataRequestCompleted: false,
        };
      default:
        return reducer(combinedState, action);
    }
  };
}
